const INFO = {
  main: {
    title: "Hugo Salles",
    name: "Hugo Salles",
    email: " ",
    // logo: "../../logo.png",
  },

  socials: {
    twitter: "https://twitter.com/",
    github: "https://github.com/",
    linkedin: "https://linkedin.com/",
    instagram: "https://instagram.com/",
    stackoverflow: "https://stackoverflow.com/",
    facebook: "https://facebook.com/",
  },

  homepage: {
    title: "Full-stack web and mobile app developer, and retired Avenger.",
    description:
      "I am a fullstack developer with expertise in both frontend and backend technologies. With a strong foundation in Node.js, React, and various frameworks, I have experience building scalable, secure, and reliable web applications. I thrive on solving complex problems and continuously learning new skills. My passion lies in creating high-quality code that adheres to best practices and industry standards. I am always seeking new challenges and opportunities to grow as a developer.",
  },

  about: {
    title: "I'm Hugo, and I'm based in Miami",
    description:
      "I've worked on a variety of projects over the years and I'm proud of the progress I've made. Many of these projects are open-source and available for others to explore and contribute to. If you're interested in any of the projects I've worked on, please feel free to check out the code and suggest any improvements or enhancements you might have in mind. Collaborating with others is a great way to learn and grow, and I'm always open to new ideas and feedback.",
  },

  //   articles: {
  //     title:
  //       "I'm passionate about pushing the boundaries of what's possible and inspiring the next generation of innovators.",
  //     description:
  //       "Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
  //   },

  projects: [
    {
      title: "Stratos Engineering",
      description:
        "A full stack site offering product knowledge for a client's engineering firm. This project involved a complete website design, including a modern logo and branding. The site was built using React, Node.js, and MongoDB, and features a user-friendly interface that allows visitors to easily navigate the site and access information about the client's services. The backend includes a secure user authentication system, data collection tools, and automated customer outreach. The result is a polished, professional website that effectively showcases the client's brand and services.",
      logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
      linkText: "View Project",
      link: "https://stratos-engineering.com/",
    },
    {
      title: "Sirena Health and Wellness",
      description:
        "Full-stack web application rebrand for Sirena Health and Wellness, transforming their online presence from the ground up. This project involved not only a modern, sleek logo redesign but also a comprehensive website overhaul that connects the brand more effectively with its audience. The new platform facilitates seamless interaction, allowing users to easily navigate services, schedule appointments, and interact with the brand. On the backend, I implemented robust systems for secure user authentication, efficient information collection, and automated customer outreach. This ensures a smooth, secure, and user-friendly experience for both the client and their customers, enhancing overall engagement and operational efficiency.",
      logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
      linkText: "View Project",
      link: "https://sirenahealthwellness.com",
    },
    {
      title: "Pride Family Care and Wellness Center",
      description:
        "A fast-tracked project was completed for a client using Wix, leveraging their existing template to create a polished landing page within a 3-day turnaround. This efficient setup was essential in preparing the business for a full website build. In addition to the landing page, CRM tools were integrated, and automation workflows were established to enhance customer management and engagement, setting the stage for the clients expanded online presence.",
      logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
      linkText: "View Project",
      link: "https://pridefamilycare.com",
    },

    // {
    //   title: "Project 2",
    //   description:
    //     "Lorem ipsum dolor sit amet. Et incidunt voluptatem ex tempore repellendus qui dicta nemo sit deleniti minima.",
    //   logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/python/python.png",
    //   linkText: "View Project",
    //   link: "https://github.com",
    // },

    // {
    //   title: "Project 3",
    //   description:
    //     "Lorem ipsum dolor sit amet. Et incidunt voluptatem ex tempore repellendus qui dicta nemo sit deleniti minima.",
    //   logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/html/html.png",
    //   linkText: "View Project",
    //   link: "https://github.com",
    // },

    // {
    //   title: "Project 4",
    //   description:
    //     "Lorem ipsum dolor sit amet. Et incidunt voluptatem ex tempore repellendus qui dicta nemo sit deleniti minima.",
    //   logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
    //   linkText: "View Project",
    //   link: "https://github.com",
    // },

    // {
    //   title: "Project 5",
    //   description:
    //     "Lorem ipsum dolor sit amet. Et incidunt voluptatem ex tempore repellendus qui dicta nemo sit deleniti minima.",
    //   logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
    //   linkText: "View Project",
    //   link: "https://github.com",
    // },
  ],
};

export default INFO;
